import { Messages } from '../../../../gen-src/Localize';

export function VirtualConnectionTableTypeMappings(props: { isExtracted: boolean; }): string {
  if (props.isExtracted) {
    return Messages.DataDetailsVirtualConnectionTableExtract();
  } else {
    return Messages.DataDetailsVirtualConnectionTableLive();
  }
}
